import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

const USER_ROLE_PATH = 'userRole'

//#region List
export function getListUserRoles(userId, rows, dto, filterRequest) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${USER_ROLE_PATH}/getList`, filterRequest, {
            params: {
                userId,
                dto,
                rows,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Page
export function getPageUserRoles(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${USER_ROLE_PATH}/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Create Or Update
export function createOrUpdateUserRole(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${USER_ROLE_PATH}/createOrUpdate`, data, {
            params: {userId},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Delete
export function deleteUserRole(userId, id) {
    return axiosInstance
        .delete(`${BACKEND_ENDPOINT}/${USER_ROLE_PATH}/deleteById`, {
            params: {userId, id},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}
//#endregion
